export default "__VITE_ASSET__e6d20c75__"